module.exports = __webpack_public_path__ + "static/media/nbc_circle.899c6b9c.png";